<template>
  <div class="v-payment-table">
    <v-update-dealer-payment-modal :payment="this.currentPayment"
                                   v-if="isShowModal" @close="closeModal"/>
    <table class="table">
      <thead>
        <tr>
          <!--1-->
          <th scope="col">Дата - Время</th>
          <!--2-->
          <th scope="col">Сумма</th>
          <!--3-->
          <th v-if="paymentType === 'dealer_payment'"
              scope="col">Дилер</th>
           <th v-else scope="col">Подписчик</th>
          <!--4-->
          <th v-if="paymentType === 'dealer_payment'"
              scope="col">Статус</th>
          <th v-else scope="col">Тел. подписчика</th>
          <!--5-->
          <th v-if="paymentType === 'subscription_payment'
           || paymentType === 'provider_payment'">
            SIM карта
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="payment in this.payments" :key="payment.id">
          <!--1-->
          <th scope="row">{{ fixDateAndTine(payment.created_at) }}</th>
          <!--2-->
          <th>{{ payment.amount }} &#8381;</th>
          <!--3-->
          <td v-if="paymentType === 'payment' || paymentType === 'subscription_payment'">
            {{ payment.user.last_name }} {{ payment.user.first_name }}
          </td>
          <td v-else-if="paymentType === 'provider_payment'">
            {{ payment.subscription.subscriber.last_name }}
            {{ payment.subscription.subscriber.first_name }}
          </td>
          <td v-else-if="paymentType === 'refund_payment'">
            {{ payment.user.last_name }}
            {{ payment.user.first_name }}
          </td>
          <td v-else>{{ payment.dealer.last_name }} {{ payment.dealer.first_name }}</td>
          <!--4-->
          <td v-if="paymentType === 'provider_payment'">
            {{ payment.subscription.subscriber.contact_phone }}
          </td>
          <td v-else-if="paymentType === 'payment' || paymentType === 'subscription_payment'
                        || paymentType === 'refund_payment'">
            {{ payment.user.contact_phone }}
            <span v-if="payment.external_id && payment.external_id !== '0001'"
                  class="badge badge-success ml-3">Банк</span>
          </td>
          <td v-else>
            <div v-if="payment.is_paid === null">
              <span class="badge badge-danger mr-3">Новый</span>
              <font-awesome-icon @click="showModal(payment.id)" :icon="['fa', 'cogs']"/>
            </div>
            <div v-if="payment.is_paid === false">
              <span class="badge badge-danger">Отменен</span>
            </div>
            <div v-if="payment.is_paid === true">
              <span class="badge badge-success">Оплачен</span>
            </div>
          </td>
          <!--5-->
          <td v-if="paymentType === 'subscription_payment'
           || paymentType === 'provider_payment'">
            <span v-if="payment.subscription.sim_card">
              {{ payment.subscription.sim_card.phone_number }}
            </span>
            <span v-else>Архив</span>
          </td>

        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import VUpdateDealerPaymentModal from '../modals/v-update-dealer-payment-modal.vue';

export default {
  name: 'v-payment-table',
  components: { VUpdateDealerPaymentModal },
  props: ['payments', 'paymentType'],
  data() {
    return {
      currentPayment: false,
      isShowModal: false,
    };
  },
  methods: {
    showModal(p) {
      this.currentPayment = p;
      this.isShowModal = true;
    },
    closeModal() {
      this.$emit('update');
      this.isShowModal = false;
    },
  },
};
</script>
